<div #baseContainer [formGroup]="rfForm" id="rating-form">
	<!-- OB List -->
	<div class="main-container relative pt-10 transition-all duration-100" [class.pt-32]="loadexpandManeuver">
		@for (ob of observations.controls; track ob; let i = $index) {
			<mat-accordion [multi]="true">
				<mat-expansion-panel class="mat-elevation-z1 maneuver-expansion-panel" [expanded]="true">
					<!-- Always keep the header; only the inner control switches -->

					<mat-expansion-panel-header #panelH class="custom-header high relative">
						<div class="ml-6 flex items-center gap-2">
							@if (isTEMIncomplete(observations.at(i))) {
								<img
									[matTooltip]="'TEM Safety Outcome is required when there is at least one active OB.'"
									src="/assets/icon_warning.svg"
									alt="TEM not selected"
									class="absolute left-4 top-1/2 size-6 flex-shrink-0 -translate-y-1/2"
								/>
							}
							<span>
								{{ maneuverDescMap[ob.value?.maneuverCode] | uppercase }}
								<span class="ml-5">
									<span class="text-lg font-bold">&nbsp;&#183;&nbsp;</span>
									{{ ob.value.maneuver }}
								</span>
							</span>
						</div>
					</mat-expansion-panel-header>
					<ng-container formArrayName="observations">
						<app-add-maneuver-form-v2
							[showExpansion]="showExpension(observations.at(i))"
							[maneuverForm]="observations.at(i)"
							[isManeuverVisible]="false"
							[isSafetyOutcomeVisible]="showTem"
							[tabIndex]="maneuverTabs"
							(selectedOBList)="listallOBComments($event)"
							[obComments]="obComments"
						></app-add-maneuver-form-v2>
					</ng-container>
				</mat-expansion-panel>
			</mat-accordion>
		}
	</div>
</div>

<!-- Instructor Notes/Comments -->
<div
	class="mb-6 mt-5 flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-bold text-black lg:bg-violet-light lg:text-violet"
>
	Instructor Notes/Comments
</div>
<div class="mb-8 grid grid-cols-1 gap-8 p-4 lg:grid-cols-2">
	<div>
		<p class="text-sm text-grey-60">Summary</p>
		<div
			class="border-1 flex h-[150px] flex-col items-stretch justify-stretch rounded border border-[#CFE3FF] text-[85%] uppercase"
		>
			<div class="flex-1 overflow-x-hidden p-3">
				@for (comment of obComments; track comment; let i = $index) {
					<div class="grid grid-cols-6 lg:grid-cols-4">
						<div>
							@if (comment?.ob !== "TEM" && comment?.ob !== "REPEAT") {
								@if (isCabinCrewForm && comment?.maneuver != " ") {
									<span class="ml-1 mr-2">{{ comment?.maneuver }} </span>
								}
								@if (comment?.isReset || comment?.lastActionDisabled || comment?.isDisabled) {
									<span class="text-yellow">{{ comment?.ob }}</span>
								} @else {
									<span [class.text-green]="comment?.action" [class.text-red]="!comment?.action">
										{{ comment?.ob }}
									</span>
								}
							}
							@if (comment?.ob === "TEM") {
								<span
									[class.text-green]="(comment?.rate ?? 0) > 1"
									[class.text-red]="(comment?.rate ?? 0) <= 1"
									[class.text-yellow]="(comment?.rate ?? 0) === -1"
								>
									{{ comment?.maneuver }} {{ comment?.ob }}
								</span>
							}
							@if (comment?.ob === "REPEAT") {
								<span class="text-yellow">
									{{ comment?.ob }}
								</span>
							}
							@if (comment?.ob !== "TEM" && comment?.ob !== "REPEAT") {
								@if (comment?.isReset) {
									<span class="text-yellow">{{ "{ Undo }" }}</span>
								} @else if (comment?.lastActionDisabled) {
									<span class="text-yellow">{{ "{ Undo N/A }" }}</span>
								} @else if (comment?.isDisabled) {
									<span class="text-yellow">{{ "{ N/A }" }}</span>
								} @else if (comment?.action != null) {
									<span [class.text-green]="comment?.action" [class.text-red]="!comment?.action">
										{{ comment?.action ? "{ added }" : "{ removed }" }}
									</span>
								}
							}
							@if (comment?.ob === "TEM") {
								<span
									[class.text-green]="(comment?.rate ?? 0) > 1"
									[class.text-red]="(comment?.rate ?? 0) <= 1"
									[class.text-yellow]="(comment?.rate ?? 0) === -1"
								>
									{{ "{ " + comment?.remarks + " }" }}
								</span>
							}
						</div>
						@if (!comment?.isReset && !comment?.lastActionDisabled && !comment?.isDisabled) {
							<span class="col-span-4 line-clamp-1 text-ellipsis lg:col-span-2">{{ comment?.instructorComment }}</span>
						}
					</div>
				}
			</div>

			<div class="flex items-center justify-end px-3 pb-3">
				<button
					(click)="viewSummaryModal()"
					class="size-6 rounded-sm bg-red pt-1 text-center text-white lg:size-8"
					matTooltip="View/Edit Comments"
				>
					<mat-icon class="text-xs lg:text-base">edit</mat-icon>
				</button>
			</div>
		</div>
	</div>
	<div>
		<p class="text-sm text-grey-60">Other Training & Observations</p>
		<div class="border-1 h-[150px] overflow-auto rounded border border-[#CFE3FF]" [formGroup]="rfForm">
			@for (maneuver of maneuvers; track maneuver; let i = $index) {
				<ng-container formArrayName="observations">
					@if (observations.controls.length > 0) {
						@for (maneuverOB of observations.controls; track maneuverOB; let i = $index) {
							@if (maneuver === maneuverOB.get("maneuver")?.value && i == 0) {
								<app-other-training-comments [maneuverForm]="observations.at(i)" [tabIndex]="tabIndex">
								</app-other-training-comments>
							}
						}
					}
				</ng-container>
			}
		</div>
	</div>
</div>
